<template>
  <RoamTransactionListTemplate
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :screenConfig="setScreenConfig"
    :barcodeScanned="barcodeScanned"
    :formsConfig="formsConfig"
    :setLoading="setLoading"
    :popupVisible="popupVisible"
    :popUpBackButtonClick="popUpBackButtonClick"
    :popUpConfig="popUpConfig"
    :popUpFormItems="popUpFormItems"
    :popUpFormDataModel="popUpFormDataModel"
  />
</template>

<script>
import RoamTransactionListTemplate from "../../../templates/roam/roam-transaction-list.vue";
import RouteMixin from "@/_mixins/route.mixin";
import { ProductUnitOfMeasureService } from "../../../_services/api/products/product-unit-of-measure.service";
import { ProductService } from "../../../_services/api/products/product.service";
import { getDefaultUserSettings } from "../../../_store/helpers";
export default {
  mixins: [RouteMixin],
  components: {
    RoamTransactionListTemplate,
  },
  data() {
    return {
      despatchScanType: "",
      setLoading: false,
      popupVisible: false,
      formDataModel: {
        Product: undefined,
        SalesUMCode: undefined,
        BarCode: undefined,
      },
      ProductCode: undefined,
      model: {},
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Product List",
        // ScreenName: "Sales Orders - To Despatch",
        selectedIndex: 1,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "ProductList",
              // filter: [["Inactive", "=", "N"]],
              serverPaging: true,
              allowGrouping: false,
            },
            // noDataMessage: {
            //   addNew: {
            //     class: "add-new",
            //     title: "No Products",
            //     // message:
            //     //   "No Locations",
            //   },
            // },
            options: {
              pageSize: 50,
              allowedPageSizes: [25, 50, 100],
              wordWrapEnabled: this.isXSmall ? false : true,
            },
            rowSelect: {
              view: this,
              page: "roam-product",
              mode: "create",
              idProperty: "Code",
            },
          },

          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
          },
          columns: [
            {
              screenField: "Product",
              gridDataField: "Description1",
              // gridLabel: "Loc. Code",
              sortOrder: "asc",
              sortIndex: 0,
              // minWidth: 115,
              allowHiding: false,
              cellTemplate: undefined,
              label: "Item",
              // cssClass: this.isXSmall ? "set-text-overflow gc-grid-description" : undefined,
              minWidth: this.isXSmall ? 130 : undefined,
              width: this.isXSmall ? 130 : undefined,
              exportFields: [
                {
                  dataField: "Code",
                  label: "Product Code",
                },
                {
                  dataField: "Description1",
                  label: "Product Description 1",
                },
              ],
            },
            {
              screenField: "ProductCategory1",
              label: "Category 1",
              cellTemplate: undefined,
              // gridLabel: "Loc. Desc.",
              // filterIndex: 0,
              minWidth: this.isXSmall ? 120 : undefined,
              width: this.isXSmall ? 120 : undefined,
            },
            {
              screenField: "ProductCategory2",
              label: "Category 2",
              cellTemplate: undefined,
              minWidth: this.isXSmall ? 120 : undefined,
              width: this.isXSmall ? 120 : undefined,
            },
            {
              screenField: "ProductCategory3",
              label: "Category 3",
              cellTemplate: undefined,
              // cssClass: this.isXSmall ? "set-text-overflow" : undefined,
              minWidth: this.isXSmall ? 120 : undefined,
              width: this.isXSmall ? 120 : undefined,
            },

            {
              screenField: "Status",
              gridDataField: "Inactive",
              gridLabel: "Status",
              fixed: false,
            },
          ],
        },
      };

      return config;
    },
    popUpFormDataModel() {
      return this.formDataModel;
    },
    popUpFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          items: [
            {
              dataField: "Product",
              label: {
                text: "Product",
              },
              editorType: "dxSelectBox",
              editorOptions: {
                dataSource: ProductService.dataSourceConfig("api/Product", {
                  select: ["Code", "Description1"],
                  filter: [["Inactive", "=", "N"]],
                  postProcess: (data) => {
                    data.forEach((element) => {
                      element.cellTemplateRecord = {
                        primary: [
                          {
                            dataField: "Description1",
                          },
                        ],
                        secondary: [
                          {
                            dataField: "Code",
                          },
                        ],
                      };
                    });

                    return data;
                  },
                }),
                itemTemplate: "Record",
                valueExpr: "Code",
                displayExpr: "Description1",
                searchExpr: ["Code", "Description1"],
                searchMode: "contains",
                showClearButton: true,
                searchEnabled: true,
                onValueChanged: () => {
                  this.productCodeOnValueChange();
                },
              },
            },
            {
              dataField: "SalesUMCode",
              label: {
                text: "UM",
              },
              editorType: "dxSelectBox",
              editorOptions: {
                dataSource: ProductService.dataSourceConfig(
                  "api/ProductUnitOfMeasureList",
                  {
                    filter: [
                      ["ProductCode", "=", this.formDataModel.Product],
                      "and",
                      ["BranchCode", "=", getDefaultUserSettings().BranchCode],
                    ],
                  }
                ),
                // itemTemplate: "Record",
                valueExpr: "UnitOfMeasureCode",
                displayExpr: "UnitOfMeasureCode",
                searchExpr: ["UnitOfMeasureCode", "BranchDescription"],
                searchMode: "contains",
                showClearButton: true,
                searchEnabled: true,
                readOnly: !this.formDataModel.Product,
                onItemClick: async (e) => {
                  this.salesUMCodeOnItemClick(e);
                },
              },
            },
            {
              dataField: "BarCode",
              label: {
                text: "BarCode",
              },
              editorType: "dxTextBox",
            },
          ],
        },
      ];
    },
    popUpConfig() {
      return {
        save: {
          text: "Update",
          clickCallback: () => {
            this.saveProductUnitOfMeasure();
          },
          disabled:
            !this.formDataModel.Product || !this.formDataModel.SalesUMCode,
        },
      };
    },
  },
  methods: {
    productCodeOnValueChange() {
      this.formDataModel.SalesUMCode = undefined;
    },
    async salesUMCodeOnItemClick(e) {
      this.model = e.itemData;
      if (e.itemData.Barcode) {
        if (this.formDataModel.BarCode == e.itemData.Barcode) return;
        let confirmBarCode = await this.$confirm(
          "This Unit of Measure already has a barcode associated with it. Do you want to change it?",
          "Validation"
        );
        if (!confirmBarCode) {
          this.formDataModel.BarCode = e.itemData.Barcode;
        }
      }
    },
    async saveProductUnitOfMeasure() {
      this.setLoading = true;
      await ProductUnitOfMeasureService.save("edit", {
        AllBranches: "Y",
        Barcode: this.formDataModel.BarCode,
        BranchCode: this.model.BranchCode,
        ConversionFactor: this.model.ConversionFactor,
        IsDefault: this.model.IsDefault,
        ProductCode: this.model.ProductCode,
        RecordId: this.model.RecordId,
        StandardCost: this.model.StandardCostSalesUM,
        StandardSell: this.model.StandardSellSalesUM,
        UnitStandardSell: this.model.StandardSellStockUM,
        UnitOfMeasureCode: this.model.SalesUnitOfMeasureCode,
      })
        .then((res) => {
          this.setLoading = false;
          if (res) this.popUpBackButtonClick();
        })
        .catch((error) => {
          this.setLoading = false;
          if (error) this.displayGenericAlert("Sales UM save failed");
        });
    },
    popUpBackButtonClick() {
      this.popupVisible = false;
      this.formDataModel = {
        Product: undefined,
        SalesUMCode: undefined,
        BarCode: undefined,
      };
    },
    barcodeScanned(barcode) {
      if (barcode) {
        this.formDataModel.BarCode = barcode;
        this.setLoading = true;
        ProductUnitOfMeasureService.getByBarcode(barcode)
          .then((res) => {
            this.setLoading = false;
            let productUOM = res.data.value[0];
            if (productUOM) {
              // this.displayGenericAlert(
              //   `Product Code : ${productUOM.ProductCode} / Product : ${productUOM.Product.Description1}`
              // );
              this.$router.push({
                path: `/roam-product/create/${productUOM.ProductCode}`,
              });
            } else {
              // this.displayGenericAlert(`Product does not exist for barcode`);
              this.popupVisible = true;
            }
          })
          .catch((err) => {
            this.setLoading = false;
            this.$logger.debug(`errors, ${JSON.stringify(err)}`);
            this.displayGenericAlert(
              "ProductUnitOfMeasureService get call failed."
            );
          });
      }
    },
  },
  async created() {},
};
</script>
